var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"wrapper",class:['button-' + _vm.type, 'button-' + _vm.size],on:{"click":_vm.btnClick}},[_c('p',{staticClass:"button-text",class:_vm.textClass},[_vm._v("\n    "+_vm._s(_vm.text)+"\n  ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }